import { Action } from '@ngrx/store';

export const SELECT_GRAPHIC = '[GRAPHIC] Select';
export const UNSELECT_GRAPHIC = '[GRAPHIC] Unselect';


export class SelectGAction implements Action {
  readonly type = SELECT_GRAPHIC;
  constructor(public GraficoSleccionado: any) {}
}

export class UnselectGAction implements Action {
  readonly type = UNSELECT_GRAPHIC;
  constructor() {}
}

export type GraphicsActions =
  | SelectGAction
  | UnselectGAction;
